import React, { useEffect, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import MobileCTA from './components/MobileCTA';

const Home = lazy(() => import('./pages/Home'));
const ServicePage = lazy(() => import('./pages/ServicePage'));
const LegalPage = lazy(() => import('./pages/LegalPage'));

const PageLoader = () => (
  <div className="min-h-[60vh] flex items-center justify-center">
    <div className="w-12 h-12 border-4 border-teal-100 border-t-teal-600 rounded-full animate-spin"></div>
  </div>
);

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col font-sans text-gray-900 bg-white">
        <Navbar />
        <main className="flex-grow">
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/back-pain" element={<ServicePage serviceId="back-pain" />} />
              <Route path="/neck-pain" element={<ServicePage serviceId="neck-pain" />} />
              <Route path="/headaches-migraines" element={<ServicePage serviceId="headaches-migraines" />} />
              <Route path="/myofascial-dry-needling" element={<ServicePage serviceId="myofascial-dry-needling" />} />
              <Route path="/privacy-policy" element={<LegalPage pageId="privacy-policy" />} />
              <Route path="/terms-of-service" element={<LegalPage pageId="terms-of-service" />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
        <MobileCTA />
      </div>
    </Router>
  );
}

export default App;